import { gql } from '@apollo/client';
export const DeleteBookingAttachmentsDocument = gql `
  mutation DeleteBookingAttachments($input: DeleteBookingAttachmentsInput!) {
    deleteBookingAttachments(input: $input)
  }
`;
